/**
 * Created by Stefano Mandruzzato on 21/03/18.
 */
import angular from 'angular';
import pecImportContainer from './pec-import.directive';
import PecImportController from './pec-import-controller';
import api from '../../components/api-service';
export default angular.module('main.pec-import-container', [
api
])
  .directive('pecImportContainer', pecImportContainer)
  .controller('PecImportController', PecImportController)
  .name;



// WEBPACK FOOTER //
// ./client/components/pec-import-container/pec-import.module.js